module.exports = __webpack_public_path__ + "static/media/How to use or manage task.e6c478e4.png";